import {notificationService} from "../services/NoificationService"

export const getNotifications = async () => {
    try {
     const res = await notificationService.get('/notifications/unread')
      console.log(res.data)
       return res.data
    } catch (error) {
    }
   
 }

 export const updateNotifications = async ( notifications: { ids: string[] } ) => {
   try {
    const res = await notificationService.post("/notifications", notifications)
      return res.data
   } catch (error) {
   }
  
}